<template>

  <div class="page-queue-stats" style="overflow: auto;">
    <resize-observer @notify="__resizeHandler"/>
    <el-tabs v-model="activeTab">
      <el-tab-pane name="IvrActivity" label="IVR Activity">
        <ivr-activity
          ref="ivrTrend"
          :ivrOptions="ivrOptions"
          @waveReady="runTableQueries"
        />
      </el-tab-pane>
      <el-tab-pane name="IvrSummary" label="IVR Summary">
        <ivr-summary
          ref="ivrSummaryTable"
          :ivrOptions="ivrOptions"
        />
      </el-tab-pane>
      <el-tab-pane name="IvrLog" label="IVR Log">
        <ivr-log
          ref="ivrLogTable"
          :ivrOptions="ivrOptions"
        />
      </el-tab-pane>
    </el-tabs>
  </div>

</template>

<script>

import ivrActivity from './components/ivr-activity';
import ivrSummary from './components/ivr-summary';
import ivrLog from './components/ivr-log';
import feathersClient from "../../../feathers/feathers-client";

export default {
  name: 'IvrStats',
  components: { ivrActivity, ivrSummary, ivrLog },
  data() {
    return {
      activeTab: 'IvrActivity',
      resized: false,
      ivrOptions: []
    }
  },
  computed: {
    user(){
      return this.$store.state.auth.user;
    },
    selectedTenant(){
      return this.$store.state.selectedTenant;
    }
  },
  watch: {
    selectedTenant(){
      this.queryIvrs();
    },
    activeTab(){
      if(this.activeTab === 'IvrActivity'){
        setTimeout(() => {
          this.$refs.queueTrend.chart.resize();
        }, 150);
      }
    }
  },
  methods: {
    async queryIvrs(){
      feathersClient.service('ivrs').find({
        query: {
          tenantId: this.selectedTenant.id,
          $sort: {
            name: 1
          }
        }
      }).then( res => {
        this.ivrOptions = [...res];
      })
    },
    __resizeHandler: _.throttle(function (e) {
      if (this.resized) {
        setTimeout(() => {
          this.$refs.ivrTrend.chart.resize();
          this.$refs.ivrTrend.keyPressPie.resize();
          this.$refs.ivrTrend.keyPressBar.resize();
          this.$refs.ivrTrend.wrongKeyPressBar.resize();
          this.$refs.ivrTrend.wrongKeyPressPie.resize();
          this.$refs.ivrTrend.othersBar.resize();
        }, 1000)
      }
      this.resized = true;
    }, 700),
    runTableQueries(){
      this.$refs.ivrSummaryTable.resetTable(true);
      this.$refs.ivrLogTable.resetTable();
    }
  },
  mounted(){
    this.queryIvrs();
  }
}

</script>
